import { Select } from 'antd'
import { useEffect, useState } from 'react'

import { axiosInstance } from '../../hooks/useAxios'
import { IMerchantOption } from '../../types/merchant'
import MerchantStatusTags from './MerchantStatusTags'

interface Props {
  value?: string
  onChange: (prefix: string) => void
  // หน้า login ยังไม่ได้เก็บ token ลงเครื่อง — ต้องส่ง header มาเอง
  headers?: Record<string, string>
}

// ร้านให้ super admin เลือก (GET /merchant/options) — ค้นด้วยรหัสหรือชื่อร้าน
const MerchantOptionSelect = ({ value, onChange, headers }: Props) => {
  const [search, setSearch] = useState<string>('')
  const [options, setOptions] = useState<IMerchantOption[]>([])
  const [isSearching, setIsSearching] = useState<boolean>(false)

  useEffect(() => {
    let cancelled = false
    setIsSearching(true)
    const handler = setTimeout(async () => {
      try {
        const { data } = await axiosInstance.get<IMerchantOption[]>(
          '/merchant/options',
          { headers, params: { search: search || undefined } },
        )
        if (!cancelled) {
          setOptions(data ?? [])
        }
      } catch (error) {
        if (!cancelled) {
          setOptions([])
        }
      } finally {
        if (!cancelled) {
          setIsSearching(false)
        }
      }
    }, 400)
    return () => {
      cancelled = true
      clearTimeout(handler)
    }
  }, [search, headers])

  return (
    <Select
      showSearch
      allowClear
      filterOption={false}
      style={{ width: '100%' }}
      placeholder="พิมพ์รหัสร้านหรือชื่อร้าน"
      loading={isSearching}
      notFoundContent={isSearching ? 'กำลังค้นหา...' : 'ไม่พบร้าน'}
      value={value || undefined}
      onSearch={setSearch}
      onChange={(next?: string) => onChange(next ?? '')}
      options={options.map((option) => ({
        value: option.prefix,
        label: (
          <span
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: 8,
            }}
          >
            <span>
              {option.name} ({option.prefix})
            </span>
            <span>
              <MerchantStatusTags
                status={option.status}
                isExpired={option.isExpired}
              />
            </span>
          </span>
        ),
      }))}
    />
  )
}

export default MerchantOptionSelect
